import axios from 'axios';
import Vue from 'vue';
import util from '@webfront-components-vue/sign-utils';
import syncUploadWhite from '@/config/syncUploadWhite';

axios.defaults.withCredentials = true;
axios.defaults.timeout = 1000 * 10;

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        resolve(err);
      });
  });
}

export function postFormData(url, data) {
  const params = data;
  const fd = new FormData();
  Object.keys(params).forEach((key) => {
    fd.append(key, params[key]);
  });
  return new Promise((resolve, reject) => {
    axios
      .post(url, fd)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

axios.interceptors.response.use(
  (response) => {
    const { headers } = response;
    const exceed = Object.keys(response.headers).find((key) => key.toLowerCase() === 'exceedmaxdevicecnt');
    if (headers?.[exceed] === 'true') {
      // 因设备退出未登录
      Vue.prototype.$CPopup({
        confirmButtonText: '重新登录', // 确认按钮文案
        text: '您同时登录的设备数过多，已被挤下线，登录新账号，可继续使用~', // 提示信息
        confirm: () => {
          window.location.href = `${process.env.VUE_APP_LOGIN_URL}?redirect_url=${encodeURIComponent(window.location.href)}&t=${new Date().getTime()}`;
          // window.location.href = `https://c.youdao.com/common-login-web/index.html?redirect_url=${local}`;
        },
        cancel: () => {
          const localUrl = encodeURIComponent(window.location.href);
          window.location.href = `https://dict.youdao.com/login/acc/se/reset?product=DICT&samesite=true&ru=${localUrl}`;
        },
      });
    }
    return Promise.resolve(response);
  },
  (error) => {
    console.log('error', error);
    if (error.message.includes('timeout')) {
      Vue.prototype.$toast('网络请求超时，请稍后再试');
      return Promise.resolve(error);
    }
    Vue.prototype.$toast('网络连接失败，请稍后重试');
    return Promise.resolve(error);
  },
);

/**
 * 获取同传请求前的数据
 * @param {*} config
 */
function getSyncUploadRequestData(config = {}) {
  const { method, data = {}, params = {} } = config;
  switch (method.toLowerCase()) {
    case 'post':
    case 'delete':
    case 'put':
      return data;
    case 'get':
      return params;
    default:
      return data;
  }
}

/**
 * 设置同传签名后的数据
 * @param {*} config
 * @param {*} data
 */
function setSyncUploadRequestData(config = {}, data) {
  const { method } = config;
  const obj = config;
  switch (method.toLowerCase()) {
    case 'post':
    case 'delete':
    case 'get':
      obj.params = data;
      break;
    default:
      obj.data = data;
      break;
  }
}

axios.interceptors.request.use(
  (axiosConfig) => {
    // 判断url是否存在同传的签名白名单中
    if (syncUploadWhite.whiteCodeList.indexOf(axiosConfig.url) !== -1) {
      const requestData = getSyncUploadRequestData(axiosConfig);
      const signData = util.genParamV3(requestData, syncUploadWhite.signSecretKey, syncUploadWhite.keyId, syncUploadWhite.product);
      setSyncUploadRequestData(axiosConfig, signData);
    }
    return axiosConfig;
  },
  (error) => {
    Promise.reject(error);
  },
);
